// Carta Nahual — compra anónima por lectura (pay-to-generate).
// Mismo contrato que runas/suenos para que PayToGenerateFlow lo consuma.

export const CREATE_PENDING_NAHUAL_REQUEST = 'NAHUAL/CREATE_PENDING_REQUEST';
export const createPendingNahualRequest = (payload) =>
  ({ type: CREATE_PENDING_NAHUAL_REQUEST, payload });
export const CREATE_PENDING_NAHUAL_SUCCESS = 'NAHUAL/CREATE_PENDING_SUCCESS';
export const createPendingNahualSuccess = (readingId, nahualLabel, signoSlug) =>
  ({ type: CREATE_PENDING_NAHUAL_SUCCESS, payload: { readingId, nahualLabel, signoSlug } });
export const CREATE_PENDING_NAHUAL_FAILURE = 'NAHUAL/CREATE_PENDING_FAILURE';
export const createPendingNahualFailure = (error) =>
  ({ type: CREATE_PENDING_NAHUAL_FAILURE, payload: error });

export const NAHUAL_CHECKOUT_REQUEST = 'NAHUAL/CHECKOUT_REQUEST';
export const nahualCheckoutRequest = (email, readingId) =>
  ({ type: NAHUAL_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const NAHUAL_CHECKOUT_SUCCESS = 'NAHUAL/CHECKOUT_SUCCESS';
export const nahualCheckoutSuccess = () => ({ type: NAHUAL_CHECKOUT_SUCCESS });
export const NAHUAL_CHECKOUT_FAILURE = 'NAHUAL/CHECKOUT_FAILURE';
export const nahualCheckoutFailure = (e) => ({ type: NAHUAL_CHECKOUT_FAILURE, payload: e });

export const NAHUAL_PAYPAL_REQUEST = 'NAHUAL/PAYPAL_REQUEST';
export const nahualPaypalOrderRequest = (email, readingId) =>
  ({ type: NAHUAL_PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const NAHUAL_PAYPAL_SUCCESS = 'NAHUAL/PAYPAL_SUCCESS';
export const nahualPaypalOrderSuccess = () => ({ type: NAHUAL_PAYPAL_SUCCESS });
export const NAHUAL_PAYPAL_FAILURE = 'NAHUAL/PAYPAL_FAILURE';
export const nahualPaypalOrderFailure = (e) => ({ type: NAHUAL_PAYPAL_FAILURE, payload: e });

export const NAHUAL_VERIFY_REQUEST = 'NAHUAL/VERIFY_REQUEST';
export const nahualVerifyPurchaseRequest = (sessionId) =>
  ({ type: NAHUAL_VERIFY_REQUEST, payload: { session_id: sessionId } });
export const NAHUAL_VERIFY_SUCCESS = 'NAHUAL/VERIFY_SUCCESS';
export const nahualVerifyPurchaseSuccess = (data) =>
  ({ type: NAHUAL_VERIFY_SUCCESS, payload: data });
export const NAHUAL_VERIFY_FAILURE = 'NAHUAL/VERIFY_FAILURE';
export const nahualVerifyPurchaseFailure = (e) => ({ type: NAHUAL_VERIFY_FAILURE, payload: e });

export const NAHUAL_VERIFY_PAYPAL_REQUEST = 'NAHUAL/VERIFY_PAYPAL_REQUEST';
export const nahualVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: NAHUAL_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const NAHUAL_VERIFY_PAYPAL_SUCCESS = 'NAHUAL/VERIFY_PAYPAL_SUCCESS';
export const nahualVerifyPaypalSuccess = (data) =>
  ({ type: NAHUAL_VERIFY_PAYPAL_SUCCESS, payload: data });
export const NAHUAL_VERIFY_PAYPAL_FAILURE = 'NAHUAL/VERIFY_PAYPAL_FAILURE';
export const nahualVerifyPaypalFailure = (e) => ({ type: NAHUAL_VERIFY_PAYPAL_FAILURE, payload: e });
